var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z",
    fill: "#3ED181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.385 4.64c.17.17.17.449 0 .618L6.284 9.36a.437.437 0 0 1-.618 0L3.615 7.309a.439.439 0 0 1 0-.618c.17-.17.448-.17.618 0l1.742 1.742L9.767 4.64a.434.434 0 0 1 .618 0z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingConfirmed);
export default __webpack_public_path__ + "static/media/booking_confirmed.216d930f4e869b68aebab76069fc728f.svg";
export { ForwardRef as ReactComponent };